/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/PipelinePermissionsCheckbox" />
import React = require("react");
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { EndpointsEditorActionsCreator } from "DistributedTaskUI/ServiceEndpoints/Editor/Actions/EndpointsEditorActionsCreator";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { EndpointsEditorStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointsEditorStore";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Checkbox } from "VSSUI/Checkbox";
import { FormItem } from "VSSUI/FormItem";



export class PipelinePermissionsCheckbox extends VssComponent {

    private readonly _endpointEditorStore: EndpointsEditorStore;
    private readonly _endpointEditorActionCreator: EndpointsEditorActionsCreator;

    constructor(context: IVssComponentContext) {
        super(context);

        this._endpointEditorStore = StoreManager.GetStore<EndpointsEditorStore>(EndpointsEditorStore, ActionsCreatorInstanceIds.EndpointsEditorStoreInstanceId);
        this._endpointEditorActionCreator = ActionCreatorManager.GetActionCreator<EndpointsEditorActionsCreator>(EndpointsEditorActionsCreator, ActionsCreatorInstanceIds.EndpointsEditorActionsCreatorInstanceId);
    }

    public render(): JSX.Element {
        const state = this._endpointEditorStore.getState();
        return (<FormItem label={Resources.SecurityHeader} className="pipeline-permissions-section default-input-margin-top">
            <Checkbox
                onChange={this._onPipelinePermissionsCheck}
                checked={state.openToAllPipelinesFlag}
                label={Resources.PipelinePermissionsCheckboxLabel} />
        </FormItem>);
    }

    private _onPipelinePermissionsCheck = (_: any, checked: boolean): void => {
        this._endpointEditorActionCreator.updateOpenToAllPipelinesFlag(checked);
    }
}
